const env = { API_URL: 'https://stage.api.cohortai.com/crud' } ;
export default env
